import gql from 'graphql-tag'
export default gql`mutation updateFamilyMutation($familyId: Int!, $family: BaseFamily!) {
  updateFamily(familyId: $familyId, family: $family) {
    name
    id
  }
}`